<app-tooltip-singleton class="fixed z-100" #tooltip />
<app-dropdown-singleton class="fixed z-100" #dropdown />

<app-context-menu
  (closeMenu)="isContextMenuOpen.set(false)"
  [headerEntityName]="contextMenuHeader()?.name"
  [headerEntityType]="contextMenuHeader()?.entityType"
  [isVisible]="isContextMenuOpen()"
  [options]="contextMenuOptions()"
  [x]="contextMenuX()"
  [y]="contextMenuY()" />
